import React, { useEffect, useState } from "react";
import LazyLoad from "react-lazyload";
import { useLocation } from "react-router-dom"; // Import useNavigate hook
import { getNewsInner } from "../Service/Api";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";
const SubGallery = () => {
  const homeMenu = [
    { label: "Awards & Achievements", link: "/awardsAcheivements" },
    {
      label: "Gallery",
      link: "/Gallery",
      subMenu: [
        { label: "Photo Gallery", link: "/Gallery" },
        { label: "Video Gallery", link: "/VideoGallery" },
      ],
    },

    {
      label: "Careers",
      link: "",
      subMenu: [{ label: "Philosophy", link: "/philosophy" }],
    },
    { label: "School Calendar", link: "/calender" },
    {
      label: "Alumni",
      link: "",
      subMenu: [
        { label: "Admissions", link: "/admission" },
        { label: "Admissions IIT", link: "/admissionIIT" },
      ],
    },

    { label: "eMagazine", link: "/Magazine" },
    { label: "TAABIR Digital Dreams", link: "/digitaldreams" },
    {
      label: "CUET",
      link: "https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/CUET.pdf",
    },
  ];

  const location = useLocation();
  const id = new URLSearchParams(location.search).get("id");
  const [data, setData] = useState("");
  const [index, setIndex] = React.useState(-1);

  console.log(id);
  useEffect(() => {
    const getData = async () => {
      try {
        let { data } = await getNewsInner(id);
        console.log("Get Inner Data list", data);
        const getfilter = data.filter((item) => item._id === id);
        console.log("Get Inner Data", { data });
        setData(getfilter[0]); // If you expect exactly one item
      } catch (error) {
        console.log(error);
      }
    };
    getData();
  }, [id]); // Add id as a dependency
  console.log(data);

  const slides = data?.attachments?.map((img) => ({
    src: `https://webapi.entab.info/api/image/${img}`,
  }));

  return (
    <>
      {" "}
      <style>
        {`
        .table table tbody td {
          width: 25%;
        }
      `}
      </style>
      <Header />
      <Breadcrumb breadImage="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/banner-vision.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page no-bread">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle={data.title}
                breadEnd={data.title}
                breadMid="News"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="fulwidth">
                <div className="discription">
                  <p dangerouslySetInnerHTML={{ __html: data.description }}></p>
                </div>
              </div>
              <div className="flexbox-v zoompic row">
                {data &&
                  data.attachments &&
                  data.attachments.length > 0 &&
                  data.attachments.map((img, index) => (
                    <div key={index} className="col-lg-3">
                      <a href={data.url}>
                        <LazyLoad>
                          <img
                            src={`https://webapi.entab.info/api/image/${img}`}
                            onClick={() => setIndex(index)}
                            className="img-fluid"
                            alt={`Image ${index}`}
                          />
                        </LazyLoad>
                      </a>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default SubGallery;
